export const TipoConvocatoria = Object.freeze({
    INTERNO:"INTERNA",
    EXTERNO:"EXTERNA",
})